import { CrossSwapOrderStatus as OrderStatus } from '@tokenlon/v6-sdk'

export const getIsFailed = (status: OrderStatus) => {
  const failedStatuses = [
    OrderStatus.OriginFailed,
    OrderStatus.OriginTimeout,
    OrderStatus.DestinationFailed,
    OrderStatus.DestinationTimeout,
    OrderStatus.UnknownFailed,
  ]
  return failedStatuses.includes(status)
}

export const getIsSuccess = (status: OrderStatus) => {
  return status === OrderStatus.DestinationSuccess
}
